import React, { useState } from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from "recharts";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, MenuItem, Select, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetRevenueAnalyticsQuery } from "../../store/api/manageAPI";

function RevenueAnalytic() {
  const navigate = useNavigate();

  // Independent state for each chart
  const [ordersTimeRange, setOrdersTimeRange] = useState("year");
  const [revenueTimeRange, setRevenueTimeRange] = useState("year");

  // Fetch Orders Data
  const { data: ordersDataRes, isLoading: isLoadingOrders } = useGetRevenueAnalyticsQuery({
    type: "orders",
    period: ordersTimeRange
  });

  // Fetch Revenue Data
  const { data: revenueDataRes, isLoading: isLoadingRevenue } = useGetRevenueAnalyticsQuery({
    type: "revenue",
    period: revenueTimeRange
  });

  // Transform Data for Charts
  // API returns { label, value }
  // Chart expects { name, orders } or { name, revenue }

  const ordersChartData = ordersDataRes?.data?.data?.map(item => ({
    name: item.label,
    orders: item.value
  })) || [];

  const revenueChartData = revenueDataRes?.data?.data?.map(item => ({
    name: item.label,
    revenue: item.value
  })) || [];

  return (
    <>
      <div className="main_title">
        <h1>Report Analytics</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Analytics
        </p>
      </div>

      <div className="grid_sc gap_m">
        {/* Orders Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Orders</h2>
            </div>
            <div className="right_s form">
              <Select
                value={ordersTimeRange}
                onChange={(e) => setOrdersTimeRange(e.target.value)}
                size="small"
              >
                <MenuItem value="day">A Day</MenuItem>
                <MenuItem value="week">A Week</MenuItem>
                <MenuItem value="month">A Month</MenuItem>
                <MenuItem value="year">A Year</MenuItem>
                {/* <MenuItem value="custom">Custom</MenuItem> */}
              </Select>
              {/* <Button className="btn btn_black icon_btn" >
                <FileDownloadIcon />
              </Button> */}
            </div>
          </div>
          <div style={{ width: '100%', height: 400 }}>
            {isLoadingOrders ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={ordersChartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="orders" fill="#38B6FF" barSize={40} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>

        {/* Revenue Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Revenue</h2>
            </div>
            <div className="right_s form">
              <Select
                value={revenueTimeRange}
                onChange={(e) => setRevenueTimeRange(e.target.value)}
                size="small"
              >
                <MenuItem value="day">A Day</MenuItem>
                <MenuItem value="week">A Week</MenuItem>
                <MenuItem value="month">A Month</MenuItem>
                <MenuItem value="year">A Year</MenuItem>
                {/* <MenuItem value="custom">Custom</MenuItem> */}
              </Select>
              {/* <Button className="btn btn_black icon_btn">
                <FileDownloadIcon />
              </Button> */}
            </div>
          </div>
          <div style={{ width: '100%', height: 400 }}>
            {isLoadingRevenue ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={revenueChartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="revenue" fill="#FF8238" barSize={40} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default RevenueAnalytic;
